"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class UserInfoRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('user_info');
    }
    /**
     * Get a user's address
     */
    getAddress() {
        return this.get(`/address`);
    }
    getUserInfo() {
        return this.get('/');
    }
    getStatus() {
        return this.get('/status');
    }
    updateUserInfo(userInfoParams) {
        return this.post('/', userInfoParams);
    }
    updateEddStatus(status) {
        return this.post('/status', { status });
    }
    updateAddress(address) {
        return this.post('/address', address);
    }
    getVerificationStatus() {
        return this.get('/verification/status');
    }
}
exports.UserInfoRoutes = UserInfoRoutes;
//# sourceMappingURL=user_info.js.map